import { render, staticRenderFns } from "./DesignOwnerForm.vue?vue&type=template&id=40828dfd&"
import script from "./DesignOwnerForm.vue?vue&type=script&lang=js&"
export * from "./DesignOwnerForm.vue?vue&type=script&lang=js&"
import style0 from "./DesignOwnerForm.vue?vue&type=style&index=0&id=40828dfd&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports